import React from 'react';
import './App.css';
import Pages from './pages/index'

function App() {
  return <Pages />;
}

export default App;
